<template>
  <div class="content">
    <nav class="nav">
      <div class="nav-content">
        <div class="logo">
          <img src="../assets/logo.png" alt="logo" style="height:30px;">
        </div>
        <div class="menulist" style="line-height: 60px;">
          <!-- 直接显示菜单项 -->
          <div style="display: inline-block;" class="menu-content">
            <el-menu
              @select="handleSelect"
              mode="horizontal"
              background-color="#000"
              text-color="#fff"
              router
              active-text-color="#ffd04b"
              :default-active="path">
              <el-menu-item index="/recordList">记录列表</el-menu-item>
              <el-menu-item index="/customerList">客户信息列表</el-menu-item>
            </el-menu>
          </div>
        </div>
        <div class="user">
          <el-menu
            style="display: inline-block;float: right;"
            :default-active="activeIndex2"
            class="el-menu-demo"
            mode="horizontal"
            @select="handleSelect"
            background-color="#000"
            text-color="#fff"
            active-text-color="#ffd04b">
            <el-submenu index="6" popper-class="user-submenu">
              <template slot="title"><span class="icon"></span>{{role_name}} <small>({{username}})</small>【项目经理端】</template>
              <el-menu-item index="6-1">修改密码</el-menu-item>
              <el-menu-item index="6-2">退出</el-menu-item>
            </el-submenu>
          </el-menu>
        </div>
      </div>
    </nav>
    <div class="main-wrapper">
      <router-view></router-view>
    </div>
    <FooterContent></FooterContent>
  </div>

</template>

<script>
  import ApiService from "../service/ApiService";
  import FooterContent from "./Common/FooterContent";
  import pub from "../service/public";
  import appConfig from "../../static/config.json";
  
  export default {
    name: "Main",
    data() {
      return {
        activeIndex: '',
        activeIndex2: '',
        username: "",
        path: '/recordList',
        role_name:'',
      }
    },
    watch: {
      // 监测路由变化,只要变化了就调用获取路由参数方法将数据存储本组件即可
      $route:{
        handler: function(val, oldVal){
          if(val.path !=oldVal.path){
            this.onRouteChanged();
          }
        },
        deep: true // 深度观察监听
      }
    },
    created() {
      // 版本校验：如本地记录版本与当前配置版本不一致，则强制退出到登录页
      const currentVersion = appConfig && appConfig.VERSION ? appConfig.VERSION : '';
      const storedVersion = localStorage.getItem('UL_WF_VERSION');

      if (storedVersion && currentVersion && storedVersion !== currentVersion) {
        // 清理登录状态并跳转到登录页
        this.$cookies.set(pub.token.token_key, '');
        this.$cookies.set(pub.token.token_role_name, '');
        this.$cookies.set(pub.token.token_usrname, '');
        this.$cookies.set(pub.token.refresh_key, '');
        localStorage.clear();
        this.$router.replace('/login');
        return;
      }

      // 若本地尚未记录版本号，则写入当前版本
      if (currentVersion && !storedVersion) {
        localStorage.setItem('UL_WF_VERSION', currentVersion);
      }

      let accountInfo = localStorage.getItem('UL_WF_UsrInfo');
      if (accountInfo) {
        this.role_name = JSON.parse(accountInfo).strUsrRealName;
      }
      this.username = this.$cookies.get('save_usrname_wf');
      this.onRouteChanged();
    },
    methods: {
      onRouteChanged() {
        this.path = this.$route.path;

        // 根据当前路由激活右上角用户菜单
        if (this.$route.path === '/changepwd') {
          this.activeIndex2 = '6-1';
        } else {
          this.activeIndex2 = '';
        }
      },
      handleSelect(key, keyPath) {
        if (key == "6-1") {
          this.activeIndex2 = '6-1';
          this.$router.push("/changepwd");
        } else if (key == "6-2") {
          this.activeIndex2 = '';
          let params = {
            page: { number: 0, limit: 1 },
            keyWord: [],
            parms: {}
          };
          ApiService.UsrLogout(params).then(res => {
            if (res.code === pub.backCode.SUCCESS) {
              this.$cookies.set(pub.token.token_key, '');//token authorization  post传值需要的
              this.$cookies.set(pub.token.token_role_name, '');
              this.$cookies.set(pub.token.token_usrname, '');//用户名
              this.$cookies.set(pub.token.refresh_key, '');//用来刷新authorization
              localStorage.clear();
              this.$router.push("/login");
            } else {
              pub.analysisReturnCode(res, () => this.handleSelect(key, keyPath));
            }
          })
        }
      },

    },
    components: {
      FooterContent: FooterContent
    }
  }
</script>

<style scoped="scoped">
  div:focus, ul:focus {
    outline: 0;
  }

  ul li {
    list-style: none;
    font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  }

  .content {
    width: 100%;
    min-height: 100vh;
    display: flex;
    flex-direction: column;
  }
  .content .nav {
    width: 100%;
    height: 60px;
    background: #000;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    position: fixed;
    top: 0;
    z-index: 200;
    min-width: 1366px;
  }
  .content .nav .nav-content {
    width: 1366px;
    height: 60px;
    margin: 0 auto;
    position: relative;
  }

  .logo {
    width: 280px;
    height: 60px;
    line-height: 60px;
    color: #00a8be;
    float: left;
    text-align: left;
  }
  .menulist {
    width: 900px;
    height: 60px;
    text-align: center;
    position: absolute;
    top: 0;
    left: 50%;
    margin-left: -450px;
    z-index: 2;
  }

  .user {
    min-width: 100px;
    height: 60px;
    line-height: 60px;
    float: right;
  }
  .user ul{
    width: 100%;
  }
  .user ul li{
    width: 100%;
    text-align: right;
  }

  .menulist ul {
    background: #fff;
    color: #000;
  }

  .menulist >>> ul:focus, .menulist .menu-content:focus {
    outline: 0;
  }

  .menulist ul li {
    display: inline-block;
    min-width: 80px;
    cursor: pointer;
  }

  .menulist ul li a {
    color: #fff;
    cursor: pointer;
  }
  .heart_list ul {
    width: 120px;
    padding: 0;
  }
  .heart_list ul li {
    color: #000;
    width: 100%;
    height: 30px;
    line-height: 30px;
    font-size: 12px;
    font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  }
  .heart_list ul li a {
    color: #000;
  }

  .heart_list ul li a:hover {
    color: #fff;
  }

  .heart_list ul li:hover {
    color: #fff !important;
    background: #18a689;

  }
  .el-menu-demo >>> .el-submenu__title {
    padding-right: 0;
  }
  .el-menu-demo >>> .el-submenu__title span{
    display: inline-block;
    width: 20px;
    height: 20px;
    background: url('../assets/img/user-icon.png') no-repeat;
    background-size: 20px;
    margin-right:8px;
  }
  .main-wrapper {
    flex: 1;
    display: flex;
    flex-direction: column;
  }
  .main-content{
    margin: 0 auto;
    width: 1366px;
    padding-top: 100px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Main.vue